import { createIcon } from '../icon'
import FilledHeartIconListingRedesign from '@/components/atoms/svg/FilledHeartIconListingRedesign'

export const FilledHeartIconListingRedesignDefault = createIcon(
  FilledHeartIconListingRedesign
)
